import React, { useContext, useEffect, useState } from "react";
import "../style.css";
import { MdOutlineCloudUpload } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "../firebase-config";
import Spinner from "./spinner";
import { StepperContext } from "../context/StepperContext";
import { motion } from "framer-motion";

export default function UploadTumbnail() {
  const { postData, setPostData, setStep2, setStep1 } =
    useContext(StepperContext);

  const [loading, setloading] = useState(false);
  const [progress, setProgress] = useState(0);

  const Upload = (e) => {
    setloading(true);
    const imgFile = e.target.files[0];
    const storageRef = ref(storage, `tumbnails/${Date.now()}-${imgFile.name}`);

    const uploadTask = uploadBytesResumable(storageRef, imgFile);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const uploadProgress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(uploadProgress);
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setPostData({ ...postData, tumbnailURL: downloadURL });
          setloading(false);
        });
      }
    );
    setStep1(true);
    setStep2(true);
  };

  const deleteFile = (ele, ind) => {
    const deleteRef = ref(storage, postData.tumbnailURL);
    deleteObject(deleteRef).then(() => {
      setPostData({ ...postData, tumbnailURL: "" });
    });
    setStep1(false);
    setStep2(false);
  };

  return (
    <motion.div
      className="w-full h-[95%] flex flex-col justify-center items-center"
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      transition={{ ease: "easeOut", duration: 0.6 }}
    >
      {!postData.tumbnailURL ? (
        <div className="w-full h-full  flex flex-col justify-center items-center">
          {loading ? (
            <Spinner msg={"Uploading your tumbnail"} progress={progress} />
          ) : (
            <div className="border-2 w-full h-full my-3 rounded-lg border-dashed border-zinc-800 flex flex-col justify-center items-center">
              <label
                className="w-full h-full flex flex-col justify-center items-center relative"
                htmlFor="upload"
              >
                <MdOutlineCloudUpload size={100} color="rgb(39 39 42)" />
                <h1 className="text-lg font-medium text-zinc-200">
                  Click to upload Your tumbnail
                </h1>
                <h3 className="text-sm font-normal text-IconHover text-opacity-50 mt-2">
                  Only a file of a jpeg, jpg, or png format is accapted
                </h3>
                <h6 className="flex w-full flex-row absolute bottom-3 justify-center text-xs text-red-400">
                  * Tumbnail is required *
                </h6>
              </label>
              {!loading && (
                <input
                  type={"file"}
                  name="upload"
                  id="upload"
                  onChange={Upload}
                  style={{ width: 0, height: 0 }}
                  accept="image/png, image/jpeg, image/jpg"
                />
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="w-full h-full py-5 rounded-lg flex flex-col justify-center items-center relative">
          <button
            className="rounded-full p-2 bg-DarkBlue absolute bottom-7 right-3 transition ease-in-out hover:scale-110"
            onClick={deleteFile}
          >
            <FaTrashAlt size={20} color="#fff" />
          </button>
          <img
            src={postData.tumbnailURL}
            className="rounded-lg w-full h-full object-cover"
          />
        </div>
      )}
    </motion.div>
  );
}
